/* eslint-disable */
var $ = window.jQuery = require('jquery');

import 'vue-datetime/dist/vue-datetime.css'

import {
  mapGetters,
  mapState
} from 'vuex';

import { Datetime } from 'vue-datetime';
import toast from '@/services/toast';

export default {
  name: 'quiz-animation',
  components: {
    datetime: Datetime,
  },
  props: [],
  data() {
    return {
      id: '',
      name: '',
      prize1: '',
      prize2: '',
      duration: '',
      start_time: ''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizAnimationByIdState'
    ]),
    getQuizAnimationDetails() {
      this.$store.dispatch('getQuizAnimationListById', {
        id: this.id
      }).then((response) => {
        this.name = this.$store.getters.getQuizAnimationByIdState.name;
        this.start_time = this.$store.getters.getQuizAnimationByIdState.start_time;
        this.duration = this.$store.getters.getQuizAnimationByIdState.duration / 60;
        this.prize1 = this.$store.getters.getQuizAnimationByIdState.prize1;
        this.prize2 = this.$store.getters.getQuizAnimationByIdState.prize2;
      })
    },
  },
  mounted() {

  },
  beforeMount() {
    if(this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getQuizAnimationDetails
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            prize1: this.prize1,
            prize2: this.prize2,
            duration: this.duration * 60,
            start_time: this.start_time
          };
          if(this.id == '') {
            this.$store.dispatch('createNewQuizAnimationList', data).then((res) => {
              if (res.status == '201') {
                this.$router.push("/course/contest/quizzes/category/")
                toast.success(res.data.msg);
              }
            }).catch((err) => {})
            return
          } else {
            let formData = {
              id: this.id,
              data: data
            };
            this.$store.dispatch('updateQuizAnimationListById', formData).then((res) => {
              if (res.status == '200') {
                this.$router.push("/course/contest/quizzes/category/")
                toast.success(res.data.msg);
              }
            }).catch((err) => {})
            return
          }

        }
      });
    }
  },
  watch: {

  }
}
